var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-component',{attrs:{"show_btn_delete":false,"show_filter_modal":"","show_previus_days":"","model_name":"expense"},on:{"modelSaved":_vm.modelSaved},scopedSlots:_vm._u([{key:"display_top",fn:function(){return [_c('total-expenses')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }